import * as mainTerms from '../mainTerms';
export const button = {
    excel: 'CSV 다운로드',
    cancel: '취소',
    search: '검색',
    selectWork: '선택 작업',
    campaign: {
        makeCampaign: mainTerms.Setting.campaign.default + ' 만들기',
        deleteCampaign: '선택된 ' + mainTerms.Setting.campaign.default + ' 삭제',
    },
    adset: {
        makeAdset: mainTerms.Setting.adset.default + ' 만들기',
        deleteAdset: '선택된 ' + mainTerms.Setting.adset.default + ' 삭제',
    },
    ad: {
        AdSetting: mainTerms.Setting.ad.default + ' 설정', 
        deleteAd: '선택된 ' + mainTerms.Setting.ad.default + ' 삭제',
        saveWeight: '가중치 저장',
    },
    audience: {
        makeAudience: mainTerms.Setting.audience.default + ' 만들기',
        deleteAudience: '선택된 ' + mainTerms.Setting.audience.default + ' 삭제',
    },
    adFolder: {
        makeAdFolder: mainTerms.Setting.adFolder.default + ' 만들기',
        deleteAdFolder: '선택된 ' + mainTerms.Setting.adFolder.default + ' 삭제',
    },
}